import watchCancelSubscriptionSaga from './cancelSubscriptionSaga';
import watchChangeSubscriptionPricingSaga from './changeSubscriptionPricingSaga';
import watchFetchPricesSaga from './fetchPricesSaga';
import watchFetchSubscriptionsSaga from './fetchSubscriptionsSaga';

const sagas = [watchFetchPricesSaga(), watchFetchSubscriptionsSaga(), watchCancelSubscriptionSaga(), watchChangeSubscriptionPricingSaga()];

export default sagas;
